module.exports = __webpack_public_path__ + "static/circle1-f00ef0773a90902e74ff37ddd9a957f5.png";